// Scripting of modals and interactions
(function($){
	$(document).on('click', 'a.open-popup-link, .open-popup-link > a', function(e) {
		e.stopPropagation();

		if(!$(this).hasClass('mp-init')) {
			$(this).magnificPopup({
				type: 'inline',
				// modal: true,
				closeOnBgClick: false,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						//
					},
					close: function() {
						//
					}
				}
			}).addClass('mp-init').click();
		}
	});

	//Open the popup from the url, if it exists
	if (window.location.hash && $(window.location.hash).length) {

		// If popup class is on the target, pop it like its hot.
		if($(window.location.hash).hasClass('standard-modal')) {
			$.magnificPopup.open({
				items: {
					src: window.location.hash,
				},
				type: 'inline',
				closeOnBgClick: false,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						// $('standard-modal-inner').attr('style', 'display:block;');
					},
					close: function() {
						// $('standard-modal-inner').attr('style', 'display:none;');
					}
				}
			});
		}
	}
})(jQuery);
